import type { Queryfilter as QueryFilter } from '@gonfalon/queryfilter/builder';
import { and, equals, toString as queryfilterToString } from '@gonfalon/queryfilter/builder';

import type { GetProjectSdkKeysOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export type GetProjectSdkKeysQueryParams = Omit<GetProjectSdkKeysOpenAPIQueryParams, 'filter' | 'expand'> & {
  filter?: {
    environmentKey?: string;
    viewKey?: string;
    kind?: 'sdk' | 'mobile';
    active?: boolean;
    name?: string;
  };
  expand?: Array<'environmentSummary' | 'viewSummaries'>;
  sort?: 'createdAt' | '-createdAt';
};

export function querySerializer(params: GetProjectSdkKeysQueryParams) {
  const searchParams = new URLSearchParams();

  if (params.filter) {
    const serialized = serializeProjectSdkKeysFilterParam(params.filter);
    if (serialized) {
      searchParams.set('filter', serialized);
    }
  }

  if (params.expand?.length) {
    searchParams.set('expand', params.expand.join(','));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.offset) {
    searchParams.set('offset', String(params.offset));
  }

  if (params.sort) {
    searchParams.set('sort', params.sort);
  }

  return searchParams.toString();
}

export function serializeProjectSdkKeysFilterParam(value: NonNullable<GetProjectSdkKeysQueryParams['filter']>) {
  const matches: QueryFilter[] = [];

  if (value.environmentKey) {
    matches.push(equals('environmentKey', value.environmentKey));
  }

  if (value.viewKey) {
    matches.push(equals('viewKey', value.viewKey));
  }

  if (value.active !== undefined) {
    matches.push(equals('active', value.active === true ? 'true' : 'false'));
  }

  if (value.kind) {
    matches.push(equals('kind', value.kind));
  }

  if (value.name) {
    // searches on name or key
    matches.push(equals('name', value.name));
  }

  return matches.length ? queryfilterToString(and(matches)) : '';
}
